<script>
	import {onDestroy} from "svelte";
	import './core/ecommerce.js';
	import {cartItemsStore, cartTotalStore, addToCart, decrementItemInCart, incrementItemInCart, loadCart} from "./cart/cart-store.js";
	import {
		filterAllergens,
		filterFavorites,
		loadFavorites,
		toggleFavorite,
		favsStore,
		filtersStore,
		publishConfigStore, tenantKeyStore, menuStore, isPaidStore, menuRecordsCountStore
	} from "./core/app-store.js";
	import {
		closeAllergensFilterPanel,
		toggleAllergensFilterPanel,
		toggleSearchPanel,
		toggleSectionsPanel,
		toggleDetailsScreen,
		openCartScreen,
		closeCartScreen,
		screensStore
	} from "./core/screens-manager.js";
	import {sanitizeText, scrollToElementId} from "./core/utils.js";
	import Filters from "./components/Filters.svelte";
	import DetailsScreen from "./details/DetailsScreen.svelte";
	import Sections from "./components/Sections.svelte";
	import RecordListItem from "./components/RecordListItem.svelte";
	import SocialLinks from "./components/SocialLinks.svelte";
	import CartWidget from "./cart/CartWidget.svelte";
	import CartScreen from "./cart/CartScreen.svelte";
	import {previewListener} from "./core/preview.js";
	import TextBlock from "./components/TextBlock.svelte";
	import SectionTitle from "./components/SectionTitle.svelte";
	import RecordCard from "./components/RecordCard.svelte";
	import Header from "./components/Header.svelte";
	import OrderScreen from "./orders/OrderScreen.svelte";
	import OrderPlacementResultScreen from "./orders/OrderPlacementResultScreen.svelte";
	import SearchPanel from "./components/SearchPanel.svelte";
	import EditDetailsHalfScreen from "./details/EditDetailsHalfScreen.svelte";
	import Divider from "./components/Divider.svelte";
	import RecordPromoted from "./components/RecordPromoted.svelte";
	import Footer from "./components/Footer.svelte";

	loadCart();

	const publishConfig = M.publishConfig;
	let tenantKey;
	let favoritesList = [];
	let screens = {};
	let nothingFound;
	let menuIsEmpty = false;

	let menu = JSON.parse(JSON.stringify(M.menu));

	const uns1 = favsStore.subscribe(list => {

		favoritesList = list;

		menuStore.update(menu => {
			menu.sections.forEach(section => {
				(section.records || []).forEach(r => {
					r.isFavorite = favoritesList.includes(r.id);
				});
			});

			return {...menu};
		})
	});

	const applyFilter = (filters) => {

		menuStore.update(menu => {

			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					const intersectedCount = (r.allergens || []).filter(a => filters.allergens.indexOf(a) > -1).length;
					const allergenFilter = intersectedCount !== 0;
					const favoritesFilter = filters.favorites === true && !favoritesList.includes(r.id);

					// clear old search result
					let searchTextFilter = false;
					r._found_desc = undefined;

					/// search by text
					if (filters.searchText && (r.name || r.description)) {

						/// search in name
						if (!r._name_lowcase) {
							r._name_lowcase = (r.name || '').toLowerCase();
						}

						searchTextFilter = r._name_lowcase.indexOf(filters.searchText) === -1;

						/// if not found, search in description
						if (searchTextFilter) {

							if (!r._description_lowcase) {
								r._description_lowcase = (r.description || '').toLowerCase();
							}

							if (r._description_lowcase.length > 0) {
								searchTextFilter = r._description_lowcase.indexOf(filters.searchText) === -1;
								if (!searchTextFilter) {
									r._found_desc = sanitizeText(r.description).replace(filters.searchText, `<em>${filters.searchText}</em>`);
								}
							}
						}
					}
					else if (!r.name || r.name.length === 0) {
						searchTextFilter = true;
					}

					r.isFilteredOut = allergenFilter || favoritesFilter || searchTextFilter;
				});

				s.isFilteredOut = (s.records || []).filter(r => !r.isFilteredOut).length === 0;
			});

			nothingFound = (menu.sections || []).filter(s => !s.isFilteredOut && s.sectionType !== 'text-block').length === 0;
			return {...menu};
		});
	}

	const unsM = menuStore.subscribe(x => {
		menu = x;

		if (screens.detailsRecord !== null && screens.detailsRecord !== undefined) {
			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					if (r.id === screens.detailsRecord.id) {
						screensStore.update(s => {
							s.detailsRecord = r;
							return s;
						})
					}
				})
			})
		}
	});
	const unsS = screensStore.subscribe(s => {
		screens = s;

		/// block body scrolling
		const hasOpenedScreens = s.detailsOpened || s.cartOpened || s.orderFormOpened || s.orderPlacementResultOpened;
		document.body.style.overflow = hasOpenedScreens ? 'hidden' : 'initial';
	});
	const unsF = filtersStore.subscribe(filters => applyFilter(filters));
	const unsT = tenantKeyStore.subscribe(key => tenantKey = key);
	const unsR = menuRecordsCountStore.subscribe(x => {
		menuIsEmpty = x === 0;
	});

	const unsC = cartItemsStore.subscribe(cartItems => {

		menuStore.update(menu => {

			// TODO: Needs optimization
			menu.sections.forEach(s => {
				(s.records || []).forEach(r => {
					r._orderedItems = 0;
					r.prices.forEach((p, idx) => {
						p._count = undefined;
						cartItems.forEach(cartItem => {
							if (r.id === cartItem.id && idx === cartItem.priceIndex) {
								p._count = cartItem.count;
								r._orderedItems += cartItem.count;
							}
						});
					});
				});
			});

			return {...menu};
		});
	});

	loadFavorites(menu);

	onDestroy(() => {
		uns1();
		unsM();
		unsS();
		unsF();
		unsT();
		unsC();
		unsR();
	});

	const removeFromCartHandler = (record) => {
		if ((record.prices || []).length > 0) {
			const index = 0;
			const price = record.prices[index];
			decrementItemInCart(record, price, index);
		}
	}

	const addToCartHandler = (record) => {

		if ((record.prices || []).length > 0) {

			const index = 0;
			const price = record.prices[index];

			if ((record._orderedItems || 0) === 0) {
				addToCart(record, price, index);
			}
			else {
				incrementItemInCart(record, price, index);
			}
		}
	}

	previewListener();
</script>

<style>

	.d {
		background-repeat: repeat-y;
		position: fixed;
		top: 0;
		width: 77px;
		height: 200vh;
		opacity: var(--bg-opacity);
		z-index: -1;
	}
	.d-l {
		background-image: url('../images/nydl.svg');
		background-repeat: repeat-y;
		position: fixed;
		top: 0;
		left: 0;
		height: 200vh;
	}
	.d-r {
		background-image: url('../images/nydr.svg');
		background-repeat: repeat-y;
		position: fixed;
		top: 0;
		right: 0;
		height: 200vh;
	}
	.d-g {
		background: var(--bg-gradient);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 200vh;
		z-index: -1;
	}

	main {
		flex: 1 1;
	}
	main .main {
		display: flex;
		flex-direction: column;
		flex: 1;
	}
	@media (min-width: 768px) {
		main {
			display: flex;
			justify-content: center;
		}
		main .main {
			max-width: 768px;
		}
		main .main .card {
			flex: 1 1 30%;
		}
	}
	.actions {
		margin: 1rem 0 0.5rem 0;
		padding: 0 1.25rem;
	}
	.action {
		padding: .5rem 0;
		font-weight: 600;
		text-transform: uppercase;
		font-size: var(--fs-100);
		letter-spacing: .35px;
		display: flex;
		align-items: center;
		gap: 0.25em;
		cursor: pointer;
	}
	.action + .action {
		padding-left: 1rem;
	}
	.action--icon {
		font-size: 1.25rem;
	}
	@media (min-width: 768px) {
		.action--icon:hover {
			color: var(--button-primary-bg-color);
		}
	}
	.filter--applied {
		position: relative;
	}
	.filter--applied:after {
		position: absolute;
		content: '';
		top: 0.15rem;
		right: -0.5rem;
		width: .5rem;
		height: .5rem;
		background: var(--fav-color);
		border-radius: 50%;
	}

	.section {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
		padding: 1rem 1.25rem;
		margin: 0;
	}

	.favorite {
		color: var(--fav-color);
	}

	footer {
		padding: 1rem;
		text-align: center;
		background: var(--footer-bg-color);
		/*margin-top: 3rem;*/
	}
	footer h2 {
		padding-top: .5rem;
		text-transform: uppercase;
		font-weight: 500;
		font-size: 1em;
	}
	footer p {
		font-size: .9rem;
	}
	footer .footer-restaurant-name {
		max-width: 100%;
		overflow-wrap: break-word;
	}

	.card {
		flex: 1 1 45%;
		min-height: 190px;
		overflow: hidden;
	}
	.card.card--ghost {
		height: 0;
		min-height: 0;
	}

	.cart-space {
		height: 3.5rem;
	}

	.no-found-panel {
		padding: 1.5rem 1.25rem 2.75rem 1.25rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 400;
		color: var(--main-font-color);
		font-size: var(--fs-100);
	}
</style>

<div class="d d-l"></div>
<div class="d d-r"></div>
<div class="d-g"></div>

<CartWidget total={$cartTotalStore}
			showTotal={$publishConfigStore.userCanSeeTotal}
			publishConfig={$publishConfigStore}
			on:openCartScreen={openCartScreen}>
</CartWidget>

<DetailsScreen></DetailsScreen>

<EditDetailsHalfScreen></EditDetailsHalfScreen>

<CartScreen opened={$screensStore.cartOpened}
			showTotal={$publishConfigStore.userCanSeeTotal}
			on:close={closeCartScreen}>
</CartScreen>

<OrderScreen></OrderScreen>

<OrderPlacementResultScreen></OrderPlacementResultScreen>

<!-- HEADER -->
<Header></Header>

<!-- MAIN CONTENT -->
<main class="layer-sections" id="dm-menu">



	<div class="main">
		<div style="padding: 1rem 1.25rem;">
			<Divider></Divider>
		</div>

		<!-- MENU SECTIONS & ITEMS -->
		{#each menu.sections as section, idx}
			{#if (section.isFilteredOut !== true || section.sectionType === 'text-block' )}

				{#if (section.sectionType === 'text-block')}
					<TextBlock section="{section}" tenantKey="{tenantKey}"/>
				{:else}
					<SectionTitle section="{section}" hideScrollToTop="{idx === 0}"/>
					<section class="section">
						{#each section.records as record, rIdx }
							{#if (record.isFilteredOut !== true)}

								{#if (record.promoted?.enabled !== true)}
									<RecordListItem record={record}
													publishConfig={publishConfig}
													tenantKey={tenantKey}
													on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
													on:addToCart={(record) => addToCartHandler(record.detail)}>
									</RecordListItem>
								{:else}
									<RecordPromoted record={record}
													publishConfig={publishConfig}
													tenantKey={tenantKey}
													noBottomLine={section.records[rIdx + 1]?.promoted?.enabled === true}
													on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
													on:addToCart={(record) => addToCartHandler(record.detail)}>
									</RecordPromoted>
								{/if}
							{/if}
						{/each}
					</section>
				{/if}

			{/if}
		{/each}

		<div style="padding: 1rem 1.25rem;">
			<Divider></Divider>
		</div>
	</div>


</main>


<Footer></Footer>
